import { Component, Injector, OnInit, ViewChild } from "@angular/core";
import { Program } from "src/app/models/program";
import { ProgramService } from "src/app/services/program.service";
import { Router, ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-list-program",
  templateUrl: "./list-program.component.html",
  styleUrls: ["./list-program.component.css"],
})
export class ListProgramComponent implements OnInit {
  programList: Program[];
  itemsCount: number;
  pageSize: number;
  pageArray: Array<number> = [];
  currentPage: number = 1;
  startIndex = 0;
  endIndex = 9;
  showPagination = false;
  productName: string;
  searchProduct = "";
  isEmpty: boolean;
  isLoading = true;

  constructor(
    private programService: ProgramService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      if (params["keyword"]) {
        this.getProgram(params["keyword"]);
      } else {
        this.searchProduct = "";
        this.productName = "";
        this.isEmpty = false;
        this.isLoading = true;
        this.getProgram(this.searchProduct);
      }
    });
  }

  public getProgram(search: string) {
    this.programList = this.programService.getProgram(
      search,
      (data) => {
        this.programList = data;

        if (this.programList.length === 0) {
          this.isEmpty = true;
        }

        this.itemsCount = this.programList.length;
        this.pageSize = Math.ceil(this.itemsCount / 9);
        this.pageArray = new Array(this.pageSize).fill(1);

        if (this.itemsCount > 9) {
          this.showPagination = true;
        }

        this.isLoading = false;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  public navigateToProgramDetail(program: Program): void {
    localStorage.setItem(program.id, JSON.stringify(program));
    this.router.navigate(["program/detail/" + program.id]);
  }

  public setPage(pageNumber) {
    this.currentPage = pageNumber;

    if (pageNumber == 1) {
      this.startIndex = 0;
      this.endIndex = 9;
    } else {
      pageNumber = pageNumber - 1;
      this.startIndex = 9 * pageNumber;
      this.endIndex = this.startIndex + 9;
    }
  }

  public onSearchProduct(searchTextValue: string) {
    if (searchTextValue == this.searchProduct) {
      this.isLoading = false;
    } else {
      this.searchProduct = searchTextValue;
      this.showPagination = false;
      this.isEmpty = false;
      // this.pageBeforeSearch = this.currentPage;
      this.setPage(1);
      this.router.navigate(["program", { keyword: this.searchProduct }]);
      this.isLoading = true;
    }
  }

  // public onKeywordChanged() {
  //   this.isEmpty = false;
  //   if (this.productName === "") {
  //     this.searchProduct = "";
  //     this.setPage(this.pageBeforeSearch);
  //     this.getProgram(this.searchProduct);
  //     this.isLoading = true;
  //   }
  // }
}
